import { render, staticRenderFns } from "./coupon-send-list.vue?vue&type=template&id=5dbd509c&scoped=true&"
import script from "./coupon-send-list.vue?vue&type=script&lang=ts&"
export * from "./coupon-send-list.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-send-list.vue?vue&type=style&index=0&id=5dbd509c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd509c",
  null
  
)

export default component.exports